import React from 'react';
import { string, arrayOf, shape, oneOfType, number } from 'prop-types';
import classnames from 'classnames';
import { Spec } from './components';
import './SpecBlock.scss';

export default function SpecBlock({ className, specs }) {
    const rootClassnames = classnames('spec-block', className);

    return (
        <div className={rootClassnames}>
            {specs.map(attribute => (
                <Spec
                    key={`${attribute.label}-${attribute.value}`}
                    className="spec-root__spec"
                    label={attribute.label}
                    value={attribute.value}
                />
            ))}
        </div>
    );
}

SpecBlock.propTypes = {
    className: string,
    specs: arrayOf(
        shape({
            label: string.isRequired,
            value: oneOfType([string, number]).isRequired,
        }),
    ),
};

SpecBlock.defaultProps = {
    className: null,
    specs: [],
};
